/** twolivetv.com money_write bank list */
export const EXCHANGE_BANKS = [
  '카카오뱅크',
  'KB국민은행',
  '신한은행',
  '우리은행',
  '하나은행',
  '외환은행',
  '토스뱅크',
  '한국산업은행',
  '기업은행',
  '수협중앙회',
  'NH농협은행',
  '대구은행',
  '부산은행',
  '광주은행',
  '제주은행',
  '전북은행',
  '경남은행',
  '산림조합',
  '새마을금고',
  '신용협동조합',
  '우체국',
  'HSBC은행',
  '스텐다드차타드은행',
  '한국씨티은행',
  '저축은행',
  '케이뱅크',
  '상호저축',
  '씨티(한미)',
] as const;
